import iconPath from '@/assets/device-icons/pro-display-xdr.svg';

interface ProDisplayXdrIconProps {
  className?: string;
}

export const ProDisplayXdrIcon = ({ className = "h-5 w-5" }: ProDisplayXdrIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="Pro Display XDR" 
      className={className}
    />
  );
};
